<template>
    <div class="video" :class="classes" :style="style">
        <video controls preload="metadata">
            <source :src="src"/>
        </video>
    </div>
</template>
<script>
export default {
    name: 'Video',
    props: {
        ratio: {
            type: Number,
            default: 16 / 9,
        },
        src: {
            type: String,
            required: true,
        },
        rounded: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        style () {
            return {
                'padding-top': `${(100 / this.ratio).toFixed(2)}%`,
            };
        },
        classes () {
            return {
                rounded: this.rounded,
            };
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

.video {
    position: relative;
    box-shadow: 6px 6px 12px 0 rgba($black, .1);

    > video {
        @include cover();
        position: absolute;
        border: none;
        background-color: $black;
    }

    &.rounded {
        border-radius: 12px;
        overflow: hidden;
    }
}
</style>
